var AOS = (function () {
  var observer = null;
  var config = { duration: 1000, offset: 60, once: true, easing: 'ease' };

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight - config.offset && rect.bottom > 0;
  }

  function applyAnimation(el) {
    var delay = parseInt(el.getAttribute('data-aos-delay') || '0', 10);
    var dur = parseInt(el.getAttribute('data-aos-duration') || config.duration, 10);
    el.style.transitionDelay = delay + 'ms';
    el.style.transitionDuration = dur + 'ms';
    el.classList.add('aos-animate');
  }

  function createObserver() {
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          applyAnimation(entry.target);
          if (config.once) observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -' + config.offset + 'px 0px', threshold: 0 });
  }

  function observeAll() {
    document.querySelectorAll('[data-aos]').forEach(function (el) {
      if (!el.classList.contains('aos-animate') || !config.once) {
        observer.observe(el);
      }
    });
  }

  return {
    init: function (opts) {
      if (opts) {
        config.duration = opts.duration || config.duration;
        config.offset = opts.offset || config.offset;
        config.once = opts.once !== undefined ? opts.once : config.once;
        config.easing = opts.easing || config.easing;
      }
      document.documentElement.style.setProperty('--aos-easing', config.easing);
      document.documentElement.style.setProperty('--aos-duration', config.duration + 'ms');
      createObserver();
      document.querySelectorAll('[data-aos]').forEach(function (el) {
        if (isInViewport(el)) {
          el.style.transitionDuration = '0s';
          el.style.transitionDelay = '0s';
          el.classList.add('aos-animate');
        }
      });
      document.documentElement.classList.add('aos-ready');
      observeAll();
    },
    refresh: function () { observeAll(); },
    refreshHard: function () { observeAll(); }
  };
})();
